<template>
    <div class="list-work" v-if="course_id != ''" :style="'height:'+(is_scroll?'100%':'auto')">
        <div class="content" :style="'overflow-y:'+(bodyHidden?'hidden':'auto')">
            <div class="work-ul">
                <div class="work-ul-li curr" style="font-size: 14px;width: 33px;">全部</div>
                <div class="work-ul-li" style="text-align:right;font-size:14px">
                    <van-checkbox shape="square"
                                  @change="handleAnimalChange"
                                  checked-color="#349BF8"
                                  icon-size="18px"
                                  style="float: right"
                                  v-model="checked">精选</van-checkbox>
                </div>
            </div>

            <div class="task-dynamic">
                <van-list
                        v-model="answerLoading"
                        :finished="is_show"
                        finished-text="暂无更多记录"
                        :immediate-check="false"
                        @load="answerListEvent"
                        offset="10"
                        v-if="list.length >0"
                >
                <div class="task-dynamic-center"  v-if="!answerLoading" v-for="(item,index) in list" :key="index">
                    <div class="task-user-logo">
                        <img :src="item.photo" :data-index="index"
                              :onerror="defaultImg" />
                    </div>
                    <div class="task-user-content">
                        <div class="task-user-info">
                            <div class="task-user-name">
                                {{item.user_name}}
                            </div>
                            <div class="task-user-icon" v-if="item.is_selected == 1">
                                <span class="iconfont iconjingxuan"></span>
                            </div>
                        </div>
                        <div class="task-user-answer">
                            <div v-text="item.content" @click="handToDetail(item)"  class="task-user-txt"></div>
                            <div class="task-user-img" v-if="item.res_type == 1">
                                <div class="my-gallery">
                                    <div @click="previewImg(item.res_datas,indexImg)" v-for="(imgItem,indexImg) in item.res_datas" :key="indexImg" :data-index="index" :data-src="imgItem">
                                        <img :src="imgItem" v-if="item.res_datas.length==1" style="height:48vw;width: 100%;" />
                                        <img :src="imgItem" v-if="item.res_datas.length>1" />
                                    </div>
                                </div>
                            </div>
                            <!-- 音频 -->
                            <div>
                                <div class="task-audio" v-if="item.res_type == 2">
                                    <div class="task-audio-btn" @click="chooseAudioWorkListPlay" :data-src="item.res_datas[0]" :data-index="index">
                                        <span :class="'iconfont '+ (item.isPlayingMusic?'iconbofang1':'iconbofang11')"></span>
                                    </div>
                                    <div class="task-audio-slider">
                                        <van-slider v-model="item.int_time"
                                                    :max="item.int_max_time"
                                                    button-size="12px"
                                                    active-color="#327CE9"
                                                    inactive-color="#cccccc"
                                                    disabled />
                                    </div>
                                    <div class="task-audio-time" v-if="item.int_max_time>0">
                                        {{item.max_time || '00:00'}}
                                    </div>
                                </div>
                            </div>
                            <div class="task-user-btn">
                                <div class="task-user-time">
                                    {{item.create_date}}
                                </div>
                                <div class="task-message-btn" @click="handleProxy" :data-user_name="item.user_name" :data-course_reply_id="item.course_reply_id" :data-index="index">
                                    <span class="iconfont iconxiaoxi2"></span>
                                    <span class="favor-cnt">{{item.reply_count}}</span>
                                </div>
                                <div class="task-info-love" @click="favorSave" :data-index="index" :data-course_reply_id="item.course_reply_id" :data-is_favor="item.is_favor">
                                    <span class="iconfont iconaixin1" :style="'color:'+(item.is_favor?'#f30':'#8a8a8a')"></span>
                                    <span class="favor-cnt">{{item.favor_count}}</span>
                                </div>
                                <div class="task-info-share" @click="handShare(item)" >
                                    <span class="iconfont iconiconfontzhizuobiaozhun20" ></span>
                                </div>
                            </div>
                        </div>

                        
                    </div>

                    <div class="comment-area" v-if="item.teacher_reply != '' || item.reply_lists.length >0 || item.favor_list.length>0">
                        <div>
                            <div class="ca-item" v-if="item.favor_list.length>0">
                                <span class="iconfont iconxinaixin" style="color:#f30;font-size: 12px"></span>
                                <span v-for="(item_fav,index_fav) in item.favor_list" :key="item_fav.user_id" style="color: #71a3ae;font-size: 12px">
                                    {{index_fav==0?item_fav.user_name:'，'+item_fav.user_name}}
                                </span>
                                <span v-if="item.favor_list.length>8">等{{item.favor_count}}人赞过</span>
                            </div>
                            <div class="ca-item" v-if="item.teacher_reply != ''">
                                <label class="pub-orange-text" style="font-weight:bold">老师点评</label>
                                <div class="pub-orange-text">
                                <span v-if="item.teacher_reply.length>80 && !item.open_text">
                                    {{item.teacher_reply.substring(0,80)+'...'}}<span style="color: #4395ff;" @click="openCommentText" :data-index="index">展开</span>
                                </span>
                                <span v-else>
                                    {{item.teacher_reply}}
                                </span>
                                </div>
                            </div>

                            <div class="ca-item" v-for="(items,indexReply) in item.reply_lists" :key="indexReply" v-if="indexReply <3">
                                <div @click="handleProxy" :data-user_name="items.user_name" :data-course_reply_id="items.course_reply_id" :data-course_reply_reply_id="items.course_reply_reply_id" :data-index="index">
                                    <label class="pub-user-text">{{items.user_name}}</label>
                                    <span v-if="items.up_course_reply_reply_id" style="padding:0 5px">回复</span>
                                    <label class="pub-user-text" v-if="items.up_course_reply_reply_id" >{{items.up_reply.user_name}}</label>
                                    ：
                                <span v-if="items.content.length>80 && !items.open_text">
                                    {{items.content.substring(0,80)+'...'}}<span style="color: #4395ff;" @clic.stop="openReplyCommentText" :data-index="index" :data-reply_index="indexReply">展开</span>
                                </span>
                                <span v-else>
                                    {{items.content}}
                                </span>
                                </div>
                            </div>
                            <div class="ca-whole-item" v-if="item.reply_lists.length>3" :data-course_reply_id="item.course_reply_id" :data-index="index" @click.stop="handToDetail(item)">
                                查看全部回复<span class="iconfont icontubiao-"></span>
                            </div>
                        </div>
                    </div>
                </div>

                </van-list>
                <van-empty description="暂无更多记录" v-if="list.length == 0"/>
            </div>
        </div>

        <div class="my-work"
              @touchmove="touchmoveFn"
              @touchend="touchendFn"
              @touchstart="touchstartFn"
              @click="workEditEvent"
              :style="'top:'+buttonTop+'px;left:'+buttonLeft+'px'" v-if="params.status">
            <div class="my-work-txt"><span class="iconfont iconxuexizhongxin"></span></div>
            <div class="my-work-txt" style="font-size:12px">
                <span v-if="params.status == 1">发表</span>
                <span v-if="params.status == 2">编辑</span>
                <span v-if="params.status == 3">查看</span>
            </div>
        </div>

        <!--回复窗口-->
        <div class="send-chat" :style="'bottom:'+chatBottom+'px'" v-if="isChat">
            <input
                    :placeholder="MsgPlaceholder"
                    @focus="getChatBottom"
                    @blur="setChatBottom"
                    @keyup.enter="sendMsg"
                    @input="setMsgDetail"
                    ref="getFocus"
                    type="text"
            />
            <div class="btn-send" @click="sendMsg">发送</div>
        </div>
       
        

        <!-- 海报相关 TODO -->
        <div v-if="share_display" class="haibao-container">
            <div>
                <div class="haibao-container-tip" >
                    <van-icon name="close" style="float: right;padding-right:5px;" size="18px" @click="handCloseShare" />
                    <span style="clear:both" >长按保存图片分享至朋友圈吧~</span>
                </div>
                <div class="haibao-container-img">
                    <img :src="share_images" alt="">
                </div>
                <div class="haibao-container-next">
                    <span class="iconfont iconxiala1"></span>
                </div>
            </div>
        </div>
        <div id="haibao-container" class="haibao-container">
            <div class="haibao-container-top">
                <div class="haibao-contents">
                    <div id="haibao-contents-create" class="haibao-contents-t">
                        <div style="position: relative;">
                            <img :src="share_info.head_images" alt="" class="haibao-contents-headimg">
                            <div style="text-align: right;position: absolute;z-index: 999" class="baibao-date" >
                                <span style="font-size: 24px;font-weight: 600; " >{{share_info.day}}</span>
                                <span style="font-weight: 600;padding-left: 10px;padding-right: 10px;" >{{share_info.date}}</span>
                            </div>
                        </div>
                        
                        <div class="haibao-contents-wrap">
                            <div v-text="share_info.content" class="haibao-contents-text">
                            </div >
                            <div class="haibao-contents-author">
                                {{share_info.author}}
                            </div>
                            <div class="haibao-contents-qr-wrap">
                                <div class="haibao-contents-qr-left">
                                    <img class="haibao-contents-qr-head" :src="share_info.user_photo+'?x-oss-process=image/format,jpg'" >
                                    <div class="haibao-contents-qr-userzone">
                                        <div class="haibaoq-qr-username">{{share_info.user_name}}</div>
                                        <div class="haibaoq-qr-tips">在『<span class="haibaoq-qr-course">{{share_info.course_name}}</span>』课程中发现精彩评论</div>
                                    </div>
                                </div>
                                <div class="haibao-contents-qr-right">
                                    <qrcode-vue :value="share_info.qr_code" size="60" level="H"></qrcode-vue>
                                    <div class="haibao-contents-qr-guide" >更多精彩</div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ImagePreview,Icon ,Checkbox,Empty,Slider,List } from 'vant';
    import html2canvas from "html2canvas";
    import QrcodeVue from "qrcode.vue";

    var startPoint;
    var innerAudioContext=null;
    var innerAudioContextIndex = 0;
    var audioInterval=null;
    export default {
        name: "course_discuss",
        components:{
            [Icon.name]:Icon,
            [Checkbox.name]:Checkbox,
            [Empty.name]:Empty,
            [Slider.name]:Slider,
            [List.name]:List,
            QrcodeVue
        },
        props:{
            course_id: {
                type:String,
                default:''
            },
            sections_id: {
                type:String,
                default:''
            },
            course_name: {
                type:String,
                default:''
            },
            scroll_top:Number,
            is_scroll:{
                type:Boolean,
                default: false
            }
        },
        data(){
            return {
                work_book_list:[],
                work_book_total:0,
                work_book_is_show:false,
                work_book_page:1,
                work_book_pageSize:100,
                isOpenWorkList:false,//查看全部作业

                defaultImg:'this.src="https://o-yzx.bysjy.com.cn/notice/photo_default.png"',//头像默认图片

                navScrollWorkLeft:0,
                navWorkItemIndex:0,
                currentWorkTab:0,

                buttonTop :0,
                buttonLeft:0,

                params:{},
                checked:false,
                scrollTop:0,

                myWork:[],
                list:[],
                total:0,
                is_show:false,
                page:1,
                pageSize:10,
                answerLoading:true,
                one_load_b:false,
                bodyHidden:false,

                chatBottom:0,//留言框bottom大小
                isChat:false,//显示留言输入框
                MsgValue:'',//留言类容
                MsgIndex:0,//留言位置
                work_answer_id:'',//问题ID
                to_work_reply_id:'',//回复人ID
                MsgPlaceholder:'回复',//留言默认显示提示
                isOpenMagList:false,//查看全部回复
                msgWork:[],//查看全部回复的当前人的主题内容

                reply_page:1,//回复列表页数
                reply_pageSize:10,//回复列表条数
                reply_list:[],//回复列表
                reply_total:0,//回复列表总数量
                is_reply_show:false,//回复列表无数据时是否显示提示
                replyLoading:true,//加载动画

                max_time:'00:00', //音频总时长
                isPlayingMusic:false,//是否播放音频
                course_reply_id:'',//课程回复列表ID
                up_course_reply_reply_id:'',//回复的回复ID

                share_display: 0, //是否显示海报
                share_images: "", //海报生成的图
                share_info: {
                    head_images: "https://o-yzx.bysjy.com.cn/yxdczh0000000187/user/2020111606381429-2738.jpeg",
                    content: "",
                    author: "",
                    user_photo: "",
                    user_name: "",
                    course_name: "示例",
                    day: "01",
                    date: "2020.11",
                    qr_code: "https://o-yzx.bysjy.com.cn/yxdczh0000000187/user/2020111606703629-3961.png",
                },
                share_default_images: [
                    "https://o-yzx.bysjy.com.cn/common/poster_bg_1.png",
                    "https://o-yzx.bysjy.com.cn/common/poster_bg_2.png",
                    "https://o-yzx.bysjy.com.cn/common/poster_bg_3.png",
                    "https://o-yzx.bysjy.com.cn/common/poster_bg_5.png",
                    "https://o-yzx.bysjy.com.cn/common/poster_bg_6.png",
                ],
                share_default_images1: [
                    "https://img.fincgo.com/mall/wx/images/20201204/5fc99a8991702.jpg",
                    "https://img.fincgo.com/mall/wx/images/20201204/5fc99a8a6c7a1.jpg",
                    "https://img.fincgo.com/mall/wx/images/20201204/5fc99a8b6c153.jpg",
                    "https://img.fincgo.com/mall/wx/images/20201204/5fc99a8c4ddc6.jpg",
                    "https://img.fincgo.com/mall/wx/images/20201204/5fc99a8d09bb4.jpg",
                    "https://img.fincgo.com/mall/wx/images/20201204/5fc99a8dcdad2.jpg",
                ]
            }
        },
        mounted() {
            this.buttonTop = Math.floor(window.innerHeight*0.8);
            this.buttonLeft = window.innerWidth-10-46;
            //this.answerListEvent(1);
        },
        methods:{
            eventInit(){
                this.answerListEvent(1);

                if(this.util.globalData.user.get() == '' && this.util.sessionid.get() != ''){
                this.util.server.mini_user.info({
                        callback: (res => {
                            this.util.globalData.user.set(res.data);
                            this.util.getUserId.set(res.data.user_id);
                            this.util.user_mobile.set(res.data.mobile);
                            this.user=this.util.globalData.user.get();
                        })
                    })
                }
            },
            bindShowWorkList(){
                this.isOpenWorkList=true;
                var _self=this;

                setTimeout(function () {
                    document.querySelector('.task-dynamic-center').scrollTop =(40*_self.navWorkItemIndex);
                },100)
            },
            closeWorkList(){
                this.isOpenWorkList=false;
            },
            //作业切换
            bindSwitchWorkBusy:function (e) {
                this.work_busy_id=e.currentTarget.dataset.work_busy_id
                this.navWorkItemIndex = e.currentTarget.dataset.index;

                this.switchWorkNav(e);
                this.closeWorkList();
                this.getDetail();
                this.bindInitData();
                this.answerListEvent(1);
            },
            bindSwitchWorkList(e){
                var index = e.currentTarget.dataset.index;
                this.work_busy_id = e.currentTarget.dataset.work_busy_id;
                this.currentWorkTab=index;
                this.navScrollWorkLeft=(110*index);
                this.navWorkItemIndex=index;

                document.querySelector('.table-scroll').scrollLeft =(110*index);


                this.closeWorkList();
                this.getDetail();
                this.bindInitData();
                this.answerListEvent(1);

            },
            //tab滑动居中
            switchWorkNav(e){
                let that = this;

                var cur  = e.currentTarget.dataset.index;
                var onheadactive = e.currentTarget.offsetLeft; // 元素距离左侧的位置
                let winweight = window.innerWidth; // 设备宽度
                let domWidth = 90; // 元素的宽度
                let distance = onheadactive - winweight / 2 + domWidth / 2;
                let sliedeLeft = onheadactive;

                if (sliedeLeft <= 0) {
                    sliedeLeft = 0;
                }

                //tab选项居中
                this.navScrollWorkLeft=distance;
                document.querySelector('.table-scroll').scrollLeft =distance;
                this.currentWorkTab=cur;

            },
            //初始化参数
            bindInitData(){
                this.myWork=[];
                this.list=[];
                this.total=0;
                this.is_show=false;
                this.page=1;
                this.pageSize=10;
                this.answerLoading=true;
                this.one_load_b=false;
                this.bodyHidden=false;

                this.chatBottom=0;//留言框bottom大小
                this.isChat=false;//显示留言输入框
                this.MsgValue='';//留言类容
                this.MsgIndex=0;//留言位置
                this.work_answer_id='';//问题ID
                this.to_work_reply_id='';//回复人ID
                this.MsgPlaceholder='回复';//留言默认显示提示
                this.isOpenMagList=false;//查看全部回复
                this.msgWork=[];//查看全部回复的当前人的主题内容

                this.reply_page=1;//回复列表页数
                this.reply_pageSize=10;//回复列表条数
                this.reply_list=[];//回复列表
                this.reply_total=0;//回复列表总数量
                this.is_reply_show=false;//回复列表无数据时是否显示提示
                this.replyLoading=true;//加载动画

                this.max_time='00:00'; //音频总时长
                this.isPlayingMusic=false;//是否播放音频
            },
            handleAnimalChange(e){

                this.checked=e;

                this.answerListEvent(1);
            },

            myWorkEvent:function(){
                var _self=this;

                this.util.server.mini_work.my_work({
                    data:{
                        work_busy_id:this.work_busy_id
                    },
                    callback:(res=>{
                        _self.myWork=res.data;
                        _self.one_load_b=true;
                    })
                })
            },
            answerListEvent:function(page){
                this.util.globalData.workEdit.set(0);
                var _self=this;
                if(!page){
                    var pageNo = this.page;
                    pageNo +=1;

                    this.page=pageNo;

                }else{

                    this.page=page;

                }
                this.util.server.mini_discus.get_reply_list({
                    data:{
                        course_id:this.course_id,
                        sections_id:this.sections_id,
                        selected_order:(this.checked?1:0),
                        page:this.page,
                        pagesize:this.pageSize
                    },
                    callback: (res => {
                        const { code, data, msg } = res;

                        _self.answerLoading=false;

                        if(code == 1) {
                            //赋值总数量
                            if(data.total){
                                _self.total = data.total
                            }
                            //1.如果有数据
                            if(data.items && data.items.length>0) {
                                console.log("22222");
                                if(page == 1){
                                    _self.list=data.items;
                                }else{
                                    //如果翻页 则在数组追加数据
                                    _self.list = _self.list.concat(data.items);
                                }

                                //判断是否存在下一页
                                this.is_show=false;

                                if(this.total*1 == this.list.length){
                                    this.is_show=true;

                                }
                                console.log("333",_self.list);
                            }else{
                                //2.无数据
                                //如果当前页为第一页 则设置页面数据为空数组
                                if (page == 1){
                                    this.list=[];
                                    this.is_show=true
                                }
                            }
                        }else{
                            this.util.showToast({
                                message: msg
                            });
                        }
                    })
                });
            },
            //替换头像错误图片
            errorimgFunction:function(e){
                var index= e.currentTarget.dataset.index;
                var src = 'https://o-yzx.bysjy.com.cn/notice/photo_default.png';

                if(this.isOpenMagList){
                    this.reply_list[index].user_photo=src
                }else{
                    this.list[index].photo=src
                }
            },
            errorMyWorkimg:function(){
                this.myWork.photo='https://o-yzx.bysjy.com.cn/notice/photo_default.png';
            },
            //作业图片查看
            previewImg:function(images, index){
                ImagePreview({
                    images: images,
                    startPosition: index,
                    closeable: true
                });
            },
            //写/编辑/查看作业
            workEditEvent:function(){
                this.one_load_b=false;
                this.util.globalData.workEdit.set(0);
                this.$router.push(this.util.urlPrefix+'/course_task/edit?work_busy_id='+this.work_busy_id+'&status='+this.params.status+'&token='+this.util.token);
            },
            //展开文字
            openCommentText:function(e){
                var index = e.currentTarget.dataset.index;

                this.list[index].open_text = 1;
            },
            openMyWorkCommentText:function(e){

                this.myWork.open_text = 1
            },
            openReplyCommentText:function(e){
                var index = e.currentTarget.dataset.index;
                var reply_index = e.currentTarget.dataset.reply_index;
                this.list[index].replys[reply_index].open_text = 1
            },
            //点赞
            favorSave:function(e){
                var index = e.currentTarget.dataset.index;
                var course_reply_id = e.currentTarget.dataset.course_reply_id;
                var is_favor = e.currentTarget.dataset.is_favor;
                
                this.util.server.mini_discus.sub_reply_favor({
                    data:{
                        course_reply_id: course_reply_id,
                        course_id: this.course_id,
                        favor_type: (is_favor==1?0:1)
                    },
                    callback:(res=>{
                        if(res.code == -1){
                            return
                        }

                        var is_favor = this.list[index].is_favor;
                        var favor_count = this.list[index].favor_count || 0;
                        var favor_list = [];

                        this.list[index].is_favor = is_favor?0:1;

                        if(is_favor){
                            favor_count--
                        }else{
                            favor_count++
                        }

                        this.list[index].favor_count=favor_count;

                        console.log("is_favor",res.data.is_favor)
                        if(!is_favor){
                            var param = {
                                user_id: this.util.getUserId.get(),
                                user_name: res.data.user_name
                            };
                            favor_list = this.list[index]['favor_list'];
                            favor_list.push(param);
                            console.log("favor_list1",favor_list)
                        }else{
                            console.log('this.list[index]',this.list[index])
                            for (var i =0;i<this.list[index].favor_list.length;i++){
                                var item = this.list[index].favor_list[i];
                                if(item.user_id == this.util.getUserId.get()){
                                    continue;
                                }
                                favor_list.push(item)
                            }
                        }
                        
                        this.list[index].favor_list = favor_list;

                        // if(this.isOpenMagList){
                        //     var msgWork = this.msgWork;
                        //     this.msgWork = msgWork;
                        // }
                    })
                })
            },
            /********************************留言start*******************************/
            //点击留言
            handleProxy:function(e){
                ;
                this.MsgPlaceholder='回复';
                this.isChat = true;
                this.course_reply_id = e.currentTarget.dataset.course_reply_id;
                this.MsgIndex = e.currentTarget.dataset.index;
                this.MsgPlaceholder = this.MsgPlaceholder + ' '+e.currentTarget.dataset.user_name;
                this.up_course_reply_reply_id = e.currentTarget.dataset.course_reply_reply_id || '';

                console.log("点击了回复course_reply_id",this.course_reply_id)
                console.log("点击了回复up_course_reply_reply_id",this.up_course_reply_reply_id)
                // var params = {
                //     MsgPlaceholder:this.MsgPlaceholder,
                //     chatBottom:this.chatBottom,
                //     isChat:this.isChat
                // };

                // this.$emit('workchatparams', {params:params});
                // TODO jhj 暂时先不用
                // if (this.timer) {
                //     clearTimeout(this.timer);
                // }
                // this.timer = setTimeout(() => {
                //     this.$refs.getFocus.focus();// 等价  document.getElementById("inputValId").focus();
                // }, 100);
            },
            //获取输入法高度
            getChatBottom:function(e){
                this.chatBottom = e.target.height || 0;

                // var params = {
                //     MsgPlaceholder:this.MsgPlaceholder,
                //     chatBottom:this.chatBottom,
                //     isChat:this.isChat
                // }
                //
                // this.$emit('workchatparams', {params:params});
            },
            //初始化留言bottom
            setChatBottom:function(){
                this.chatBottom=0;
                if(this.MsgValue  == ''){
                    this.isChat = false;
                    this.work_answer_id = '';
                    this.to_work_reply_id = '';
                    this.MsgValue = '';
                    this.MsgIndex = 0;
                    this.MsgPlaceholder = '回复';
                }
                // var params = {
                //     MsgPlaceholder:this.MsgPlaceholder,
                //     isChat:this.isChat,
                //     chatBottom:this.chatBottom
                // };
                //
                // this.$emit('workchatparams', {params:params});
            },
            closeMsg:function(){
                this.isChat = false;
                this.work_answer_id = '';
                this.to_work_reply_id = '';
                this.MsgValue = '';
                this.MsgIndex = 0;
                this.MsgPlaceholder = '回复';
            },
            //发送留言
            sendMsg:function(e){
                var val = this.MsgValue.replace(/\s+/g, '');
                var _self=this;
                if(val == ''){
                    return this.util.showToast({
                        message:'回复内容不能为空'
                    });
                    // this.setData({
                    //   isChat:false,
                    //   work_answer_id:'',
                    //   to_work_reply_id:'',
                    //   MsgIndex:0,
                    //   MsgPlaceholder:'回复'
                    // });
                    // return false;
                }

                this.util.server.mini_discus.sub_reply_reply({
                    data:{
                        course_id:this.course_id,
                        course_reply_id:this.course_reply_id,
                        up_course_reply_reply_id:this.up_course_reply_reply_id,
                        content:val
                    },
                    callback:(res=>{

                        if(res.code == -1){
                            this.isChat = false;
                            this.course_reply_id = '';
                            this.up_course_reply_reply_id = '';
                            this.MsgIndex = 0;
                            this.MsgValue = '';
                            this.MsgPlaceholder = '回复';
                            return false;
                        }

                        var replyArr = this.list[this.MsgIndex].reply_lists;
                        //var reply = 'list['+this.MsgIndex+'].reply_lists';
                        this.list[this.MsgIndex].reply_count ++

                        var arr=[];
                        arr.push(res.data.item);
                        arr = arr.concat(replyArr);
                        
                        this.list[this.MsgIndex].reply_lists = arr;
                        console.log('this.list[',this.list)
                        if(this.isOpenMagList && 0){ // TODO
                            var replyArr = this.reply_list;

                            var arr=[];
                            arr.push(res.data.item);
                            arr = arr.concat(replyArr);

                            this.reply_list = arr;
                        }
                        this.isChat = false;
                        this.course_reply_id = '';
                        this.up_course_reply_reply_id = '';
                        this.MsgIndex = 0;
                        this.MsgValue = '';
                        this.MsgPlaceholder = '回复';

                        var params = {
                            MsgPlaceholder:this.MsgPlaceholder,
                            isChat:this.isChat,
                            chatBottom:this.chatBottom
                        };
                        _self.$emit('workchatparams', {params:params});
                    })
                })
            },
            //回显输入内容
            setMsgDetail:function(e){
                var val = e.target.value;
                this.MsgValue = val;
                console.log(this.MsgValue);
            },
            //查看全部回复
            openMagList:function(e){
                this.list[innerAudioContextIndex].isPlayingMusic=false;
                if(innerAudioContext && !innerAudioContext.pause()){
                    innerAudioContext.pause();
                }
                clearInterval(audioInterval);
                var index =e.currentTarget.dataset.index;
                var work = this.list[index];
                var work_answer_id = e.currentTarget.dataset.work_answer_id;
                work.index =index;
                work.isPlayingMusic=false;
                // work.int_max_time=0;
                // work.max_time=0;
                // work.int_time=0;

                this.isOpenMagList = true;
                this.bodyHidden = true;
                this.msgWork = work;
                this.work_answer_id = work_answer_id;
                this.list[index].isPlayingMusic = false;
                this.$forceUpdate();


                this.getReplyList(1);
            },
            getReplyList:function(page){

                var _self=this;
                if(!page){
                    var pageNo = this.reply_page;
                    pageNo +=1;

                    this.reply_page = pageNo;

                }else{

                    this.reply_page = page;

                }

                this.util.server.mini_work.reply_list({
                    data:{
                        work_answer_id:this.work_answer_id,
                        page:this.reply_page,
                        pagesize:this.reply_pageSize
                    },
                    callback: (res => {
                        const { code, data, msg } = res;
                        this.replyLoading = false;
                        if(code == 1) {

                            //赋值总数量
                            if(data.total){
                                this.reply_total = data.total
                            }
                            //1.如果有数据
                            if(data.items && data.items.length>0) {

                                if(page == 1){
                                    this.reply_list = data.items
                                }else{
                                    //如果翻页 则在数组追加数据
                                    this.reply_list = this.reply_list.concat(data.items);
                                }

                                //判断是否存在下一页
                                this.is_reply_show = false;

                                if(this.reply_total*1 == this.reply_list.length){
                                    this.is_reply_show = true;
                                }

                            }else{
                                //2.无数据
                                //如果当前页为第一页 则设置页面数据为空数组
                                if (page == 1){
                                    this.reply_list = [];
                                    this.is_reply_show = true;
                                }
                            }
                        }else{
                            this.util.showToast({
                                message: msg
                            });
                        }
                    })
                });
            },
            //关闭全部回复
            closeMagList:function(){
                if(innerAudioContext && !innerAudioContext.pause()){
                    innerAudioContext.pause();
                }
                clearInterval(audioInterval);
                this.list[this.msgWork.index].isPlayingMusic = false;
                this.isOpenMagList = false;
                this.bodyHidden = false;
                this.msgWork = [];
                this.work_answer_id = '';
                this.reply_list = [];
                this.reply_total = 0;

                this.closeMsg();
            },
            lowerThresholdMag:function(){
                var list=this.list;
                if(list.length == this.total){
                    this.is_show = true;
                    return false;
                }
                this.answerListEvent();
            },
            lowerThresholdReply:function(){
                var list=this.reply_list;
                if(list.length >= this.reply_total){
                    this.is_reply_show = true;
                    return false;
                }
                this.getReplyList();
            },
            /********************************留言end*******************************/
            touchmoveFn(e){
                var endPoint = e.touches[e.touches.length - 1]
                var translateY = endPoint.clientY - startPoint.clientY
                var translateX = endPoint.clientX - startPoint.clientX
                startPoint = endPoint
                var buttonTop = this.buttonTop + translateY
                var buttonLeft = this.buttonLeft + translateX
                if (buttonLeft + 50 >= window.innerWidth) {
                    buttonLeft = window.innerWidth - 50;
                }
                if (buttonLeft <= 10) {
                    buttonLeft = 10;
                }
                if (buttonTop <= 0) {
                    buttonTop = 0
                }
                if (buttonTop + 100 >= window.innerHeight) {
                    buttonTop = window.innerHeight - 100;
                }
                this.buttonTop = buttonTop;
                this.buttonLeft = buttonLeft;
            },
            touchstartFn(e){
                startPoint = e.touches[0]
            },
            touchendFn(){
                var halfWidth = Math.floor(window.innerWidth/2);
                var buttonLeft = 10;
                if(this.buttonLeft>halfWidth){
                    buttonLeft = window.innerWidth-46-10;
                }
                this.buttonLeft = buttonLeft;
            },
            //播放音频
            chooseAudioWorkListPlay:function (e) {

                var src = e.currentTarget.dataset.src;
                var index = e.currentTarget.dataset.index;
                var _self=this;
                if(innerAudioContext && !innerAudioContext.pause()){
                    innerAudioContext.pause();
                }

                clearInterval(audioInterval);

                var isPlayingMusic = this.list[index].isPlayingMusic || false;

                if(isPlayingMusic){
                    this.list[index].isPlayingMusic = false;
                    this.$forceUpdate();
                    innerAudioContext.pause();

                }else{
                    this.list[index].isPlayingMusic = true;
                    this.list[innerAudioContextIndex].isPlayingMusic=false;
                    this.$forceUpdate();
                    innerAudioContextIndex = index;
                    innerAudioContext = new Audio();
                    innerAudioContext.src=src;
                    if(!_self.list[index].int_max_time){
                        innerAudioContext.addEventListener('loadedmetadata', function() {
                            _self.list[index].max_time=_self.util.getTime(innerAudioContext.duration);
                            _self.list[index].int_max_time=innerAudioContext.duration;
                            _self.list[index].int_time=innerAudioContext.currentTime;
                            _self.$forceUpdate();
                        })
                    }
                    innerAudioContext.play();
                    innerAudioContext.currentTime=0;
                    this.setAudioInterval(index);
                }
            },
            chooseAudioMsgWorkPlay:function(e){
                var src = e.currentTarget.dataset.src;
                var _self=this;
                if(innerAudioContext && !innerAudioContext.pause()){
                    innerAudioContext.pause();
                }
                clearInterval(audioInterval);
                var isPlayingMusic = this.msgWork.isPlayingMusic || false;

                if(isPlayingMusic){
                    this.msgWork.isPlayingMusic = false;
                    this.$forceUpdate();
                    innerAudioContext.pause();
                }else{
                    this.msgWork.isPlayingMusic = true;
                    this.$forceUpdate();
                    innerAudioContext = new Audio();
                    innerAudioContext.src=src;
                    if(!this.msgWork.int_max_time){
                        innerAudioContext.addEventListener('loadedmetadata', function() {
                            _self.msgWork.max_time=_self.util.getTime(innerAudioContext.duration);
                            _self.msgWork.int_max_time=innerAudioContext.duration;
                            _self.msgWork.int_time=innerAudioContext.currentTime;
                            _self.$forceUpdate();
                        })
                    }
                    innerAudioContext.play();
                    innerAudioContext.currentTime=0;
                    this.setAudioWorkInterval();
                }
            },
            //设置定时检测
            setAudioInterval(index){
                audioInterval = setInterval(()=>{

                    this.list[index].int_time = innerAudioContext.currentTime;
                    this.$forceUpdate();
                    if(innerAudioContext.ended){
                        //播放结束后重置数据
                        clearInterval(audioInterval);

                        this.list[index].isPlayingMusic=false;
                        this.$forceUpdate();
                        innerAudioContext.currentTime=0;
                    }
                    if(innerAudioContext.paused){
                        this.list[index].isPlayingMusic=false;
                        this.$forceUpdate();
                    }else{
                        this.list[index].isPlayingMusic=true;
                        this.$forceUpdate();
                    }
                },500)
            },
            //设置定时检测
            setAudioWorkInterval(){
                audioInterval = setInterval(()=>{

                    this.msgWork.int_time = innerAudioContext.currentTime;
                    this.$forceUpdate();
                    if(innerAudioContext.ended){
                        //播放结束后重置数据
                        clearInterval(audioInterval);

                        this.msgWork.isPlayingMusic=false;
                        this.$forceUpdate();
                        innerAudioContext.currentTime=0;
                    }
                    if(innerAudioContext.paused){
                        this.msgWork.isPlayingMusic=false
                        this.$forceUpdate();
                    }else{
                        this.msgWork.isPlayingMusic=true
                        this.$forceUpdate();
                    }
                },500)
            },
            handShare(item){
                const _this = this
                console.log('item',item)
                const userinfo = this.util.globalData.user.get()
                console.log('分享本地用户','userinfo', userinfo)
                this.share_info.content = item.content
                this.share_info.author = item.user_name
                this.share_info.user_photo = userinfo.photo
                this.share_info.user_name = userinfo.user_name
                this.share_info.course_name = this.course_name

                let mydate = new Date()
                this.share_info.day = mydate.getDate()
                this.share_info.date = mydate.getFullYear()+'.'+ (mydate.getMonth()+1)

                this.share_info.qr_code = window.location.origin+this.util.urlPrefix+'/discuss/detail?course_reply_id='+item.course_reply_id+'&token='+this.util.token

                console.log('this.share_info.qr_code',this.share_info.qr_code);
                //如果有则使用上传的，否则使用系统默认
                if(item.res_datas && item.res_datas.length>0 && 0){
                    this.share_info.head_images = item.res_datas[0]
                }else{
                    const len = this.share_default_images.length
                    const index = Math.floor((Math.random()*len))
                    this.share_info.head_images = this.share_default_images[index]
                }
                console.log('this.share_info', this.share_info)
                this.share_display = 1
                this.$nextTick(() => {
                    console.log(222);
                    html2canvas(document.getElementById('haibao-contents-create'),{
                        useCORS:true,
                        tainttest: true, //检测每张图片都已经加载完成
                    }).then(canvas => {

                        var url = canvas.toDataURL();
                        console.log("图片生成中...")
                        _this.share_images = url;
                    });
                });
                
            },
            handCloseShare(){
                this.share_display = 0
            },
            handToDetail(item){
                this.$router.push(this.util.urlPrefix+'/discuss/detail?course_reply_id='+item.course_reply_id+'&token='+this.util.token);
            }
        },
    }
</script>

<style scoped>
    .list-work{
        height: 100%;
        display: flex;
        flex: 1;
        flex-direction: column;
    }
    .table{
        width: 100%;
        position: relative;
        padding: 10px 10px 0 10px;
        box-sizing: border-box;
    }
    .flex-table{
        display: inline-block;
        font-size: 12px;
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 5px 10px;
        width: 90px;
    }
    .flex-table.curr{
        background-color: #efefef;
        border-radius: 5px;
        color: #000000;
    }
    .whole{
        position: absolute;
        top: 10px;
        right: 10px;
        width: 30px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        background-color: #fff;
        /*box-shadow: -8px -8px 10px #ffff;*/
    }
    .whole .iconfont{
        font-size: 20px;
    }
    .work-info{
        padding: 0 10px;
        box-sizing: border-box;
        width: 100%;
    }
    .table-scroll{
        white-space: nowrap;
        padding-right: 30px;
        box-sizing: border-box;
        width: 100%;
        padding-bottom:5px;
        border-bottom: 1px solid #f8f9fb;
    }
    ::-webkit-scrollbar {
        width: 0;
        height: 0;
        color: transparent;
    }
    .content{
        width: 100%;
        height: 100%;
        background-color: #fff;
        /*display: flex;*/
        /*flex: 1;*/
    }
    .header{
        padding: 10px;
    }
    .inner{
        position: relative;
    }
    .inner .task-name{
        padding-right: 50px;
        display: inline-block;
        width: 100%;
        box-sizing: border-box;
        font-size: 12px;
    }
    .inner .task-state{
        position: absolute;
        top: 2px;
        right: 0;
        font-size: 12px;
    }
    .inner .task-date{
        font-size: 12px;
        color: #aaa;
        padding-top: 5px;
        padding-bottom: 10px;
    }
    .task-state .not{
        color: #f30;
    }
    .task-state .commented{
        color: #57c78b;
    }
    .task-state .submitted{
        color: #337ab7;
    }
    .task-question{
        font-weight: bold;
    }
    .mag-list{
        position: fixed;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.5);
        transition:all .2s ease-in-out;
        opacity:0;
        visibility:hidden;
        left: 0;
    }
    .i-as-mask-show{
        opacity:1;
        visibility:visible
    }
    .mag-list .work-content{
        height: 65%;
        width: 100%;
        position: absolute;
        background-color: #ffffff;
        transform:translate3d(0,100%,0);
        transform-origin:center;
        transition:all .2s ease-in-out;
        top: 35%;
        visibility:hidden;
        z-index: 10;
        border-radius: 20px 20px 0 0;
        overflow: hidden;
        padding: 0 15px;
        box-sizing: border-box;
        display: flex;
        flex: 1;
        flex-direction: column;
    }
    .mag-list .i-as-show{
        transform:translate3d(0,0,0);
        visibility:visible
    }
    .work-header .work-header-txt{
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        padding: 10px 0;
        border-bottom: 1px solid #ccc;
        position: relative;
    }
    .work-header-txt .icon{
        position: absolute;
        right: 0;
        top: 10px;
    }
    .task-dynamic-center{
        margin: 10px 0;
        position: relative;
        /*display: flex;*/
        /*flex: 1;*/
    }
    .task-li{
        padding: 10px;
        border-bottom: 1px dashed #ccc;
    }
    .task-li-left{
        display: inline-block;
        width: 77%;
        vertical-align: middle;
    }
    .task-li-right{
        vertical-align: middle;
        display: inline-block;
        text-align: right;
        width: 23%;
    }
    .task-li-right .iconfont{
        vertical-align: middle;
    }
    .task-li-right .task-li-txt.not{
        color: #f30;
    }
    .task-li-right .task-li-txt.commented{
        color: #57c78b;
    }
    .task-li-right .task-li-txt.submitted{
        color: #337ab7;
    }
    .no-list{
        text-align: center;
        width: 100%;
        margin-top: 10px;
        color: #999;
        font-size: 12px;
    }
    .work-ul{
        display: table;
        width: 100%;
        overflow: hidden;
    }
    .work-ul .work-ul-li{
        background-color: #fff;
        display: table-cell;
        padding: 0 5px;
        height: 40px;
        text-align: center;
        vertical-align: middle;
        position: relative;
    }
    .work-ul .work-ul-li.curr:after {
        position: absolute;
        content: "";
        bottom: 0;
        width: 30px;
        height: 2px;
        background: rgba(52, 155, 248, 1);
        opacity: 1;
        border-radius: 4px;
        left: 50%;
        margin-left: -15px;
    }
    .task-user-logo{
        width: 40px;
        font-size: 0;
        position: absolute;
        top: 0;
    }
    .task-user-logo img{
        width: 40px;
        height: 40px;
        border-radius: 20px;
    }
    .task-user-content{
        display: inline-block;
        width: 100%;
        box-sizing: border-box;
    }
    .task-user-info{
        position: relative;
        height: 40px;
        line-height: 40px;
        padding-left: 50px;
    }
    .task-user-info .task-user-name{
        display: inline-block;
        max-width: 120px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .task-user-info .task-user-icon{
        display: inline-block;
        vertical-align: top;
        font-size: 20px;
        margin-left: 10px;
    }
    .task-user-info .task-user-icon .iconfont{
        font-size: 20px;
        color: #fd8b8b;
    }
    .task-user-info .task-edit{
        position: absolute;
        right: 0;
        top: 0;
        width: 40px;
        text-align: center;
        color: #4395ff;
    }
    .task-user-answer .task-user-img{
        overflow: hidden;
        margin-top: 15px;
        font-size: 0;
        padding-bottom: 5px;
    }
    .my-gallery{
        width: 100%;
        float: left;
    }
    .my-gallery div{
        display: block;
        float: left;
        margin: 0 2px 2px 0;
    }
    .my-gallery div img{
        width: 24vw;
        height: 24vw;
        display: block;
        object-fit: cover;
    }
    /*.task-user-answer .task-user-img img{*/
    /*width: 40px;*/
    /*height: 40px;*/
    /*border-radius: 10px;*/
    /*margin-right: 10px;*/
    /*margin-bottom: 10px;*/
    /*}*/

    .task-user-answer .task-user-txt{
        margin: 10px 0;
        white-space: pre-wrap;
    }
    .task-user-btn{
        display: flex;
    }
    .task-user-btn .task-user-time{
        font-size: 12px;
        color: #aaa;
        flex: 1;
        line-height: 23px;
    }
    .task-user-btn .task-message-btn{
        width: 40px;
        text-align: center;
    }
    .task-user-btn .task-info-love{
        text-align: right;
        min-width: 40px;
    }
    .task-user-btn .task-info-share{
        text-align: right;
        min-width: 34px;
    }
    .task-user-btn .iconfont{
        color: #8a8a8a;
        font-size: 20px;
    }
    .task-dynamic{
        padding: 10px;
    }
    .task-dynamic-title{
        padding-bottom: 2px;
        border-bottom: 3px solid #666;
        width: 90px;
        font-weight: bold;
    }
    .task-dynamic-center{
        margin: 10px 0;
        position: relative;
    }
    .comment-area{
        background: #f5f5f5;
        border-radius: 4px;
        margin-top: 5px;
        padding: 5px 0;
        margin-bottom: 5px;
        position: relative;
    }
    .comment-area::before{
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        border: 8px solid transparent;
        border-color: transparent transparent #f5f5f5 transparent;
        border-top-width: 0;
        top: -8px;
        left: 20px;
    }
    .comment-area .ca-item{
        padding: 0 5px;
        position: relative;
        padding-bottom: 3px;
    }
    /*.task-dynamic .task-dynamic-center:last-child{*/
    /*margin-bottom: 41px;*/
    /*}*/
    .pub-orange-text{
        color: #ff9234;
    }
    .ca-whole-item{
        font-size: 12px;
        padding: 0 5px;
        color: #4395ff;
        padding-top: 5px;
    }
    .ca-whole-item .iconfont{
        vertical-align: middle;
    }
    .edit-task{
        position: fixed;
        bottom: 0;
        background-color: #fff;
        width: 100%;
        border-top: 1px solid #ccc;
        text-align: center;
        padding: 10px 0;
    }
    .pub-user-text{
        color: #71a3ae;
    }
    .send-chat{
        position: fixed;
        bottom: 0;
        width: 100%;
        padding: 5px;
        background-color: #fff;
        box-sizing: border-box;
        -o-box-sizing: border-box;
        -ms-box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        z-index: 99999;
    }
    .send-chat .input{
        padding: 5px;
        background-color: #f3f3f3;
        padding-right: 47px;
        cursor: auto;
        display: block;
        height: 1.4rem;
        text-overflow: clip;
        overflow: hidden;
        white-space: nowrap;
        font-family: UICTFontTextStyleBody;
        min-height: 1.4rem;
    }
    .chat-content .chat-details{
        width: 100%;
        height: 100%;
        padding: 10px;
        /*overflow-y: auto;*/
        box-sizing: border-box;
        -o-box-sizing: border-box;
        -ms-box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
    .send-chat .btn-send{
        position: absolute;
        top: 0;
        right: 0;
        height: 30px;
        margin-right: 5px;
        margin-top: 5px;
        padding: 1px 5px;
        line-height: 30px;
        letter-spacing: 2px;
        border-left: 1px solid #ccc;
        background-color: #f3f3f3;
    }
    .mag-list{
        position: fixed;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.5);
        transition:all .2s ease-in-out;
        opacity:0;
        visibility:hidden
    }
    .i-as-mask-show{
        opacity:1;
        visibility:visible
    }
    .mag-list .msg-content{
        height: 65%;
        width: 100%;
        position: absolute;
        background-color: #ffffff;
        transform:translate3d(0,100%,0);
        transform-origin:center;
        transition:all .2s ease-in-out;
        top: 35%;
        visibility:hidden;
        z-index: 10;
        border-radius: 20px 20px 0 0;
        overflow: hidden;
        padding: 0 15px;
        box-sizing: border-box;
    }
    .mag-list .i-as-show{
        transform:translate3d(0,0,0);
        visibility:visible
    }
    .msg-header .msg-header-txt{
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        padding: 10px 0;
        border-bottom: 1px solid #ccc;
        position: relative;
    }
    .msg-header-txt .icon{
        position: absolute;
        right: 0;
        top: 10px;
    }
    .msg-h1{
        font-weight: bold;
        font-size: 16px;
        text-align: center;
        position: relative;
        display: inline-block;
    }
    .msg-h1:after,.msg-h1:before{
        content: '';
        position: absolute;
        height: 2px;
        width: 30px;
        background-color: #ccc;
        top: 50%;
        border-radius: 2px;
    }
    .msg-h1:before{
        left: -40px;
    }
    .msg-h1:after{
        right: -40px;
    }
    .no-list{
        text-align: center;
        width: 100%;
        color: #999;
        font-size: 12px;
    }
    .favor-cnt{
        font-size: 12px;
        padding-left: 5px;
        vertical-align: middle;
    }
    .task-info-love .iconaixin1{
        vertical-align: middle;
    }
    .task-message-btn .iconxiaoxi2{
        vertical-align: middle;
    }
    .task-audio{
        min-width: 256px;
        background-color: #eee;
        margin: 10px 0;
        display: inline-block;
        position: relative;
    }
    .task-audio-btn{
        display: inline-block;
        vertical-align: middle;
        padding: 10px;
        padding-right: 5px;
    }
    .task-audio-btn .iconfont{
        font-size: 26px;
        color: #327CE9;
    }
    .task-audio-slider{
        display: inline-block;
        width: 167px;
        vertical-align: middle;
        margin: 10px;
    }
    .slider{
        margin: 10px;
    }
    .task-audio-time{
        display: inline-block;
        vertical-align: middle;
        font-size: 12px;
        padding-right: 10px;
        padding-left: 10px;
    }
    .send-msg-content{
        width: 300px !important;
        border-radius: 5px !important;
        height: 220px !important;
        left: 50% !important;
        margin-left: -150px !important;
    }
    .send-msg-content .input{
        width: 100%;
        background-color: #f3f3f3;
        height: 120px;
        padding: 10px;
        box-sizing: border-box;
    }
    .send-msg-content .send-title{
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        padding: 10px 0;
    }
    .send-msg-content .send-btn{
        display: flex;
        margin-top: 10px;
    }
    .send-msg-content .send-btn .send-btn-close{
        flex: 1;
        text-align: center;
        background-color: #f3f3f3;
        border-radius: 30px;
        padding: 5px 0;
        margin-right: 10px;
    }
    .send-msg-content .send-btn .send-btn-ok{
        flex: 1;
        text-align: center;
        background-color: #327CE9;
        color: #fff;
        padding: 5px 0;
        border-radius: 30px;
    }
    .my-task-center{
        position: relative;
    }
    .send-chat input{
        padding: 5px;
        background-color: #f3f3f3;
        padding-right: 47px;
        border: 0;
        width: 100%;
        height: 32.39px;
        box-sizing: border-box;
    }
    .my-work{
        color: #fff;
        position: fixed;
        top: 80%;
        background-color: #327CE9;
        border-radius: 50%;
        text-align: center;
        padding: 6px 11px;
    }
    .my-work .my-work-txt{
        color: #fff;
    }
    #haibao-container{
        position: fixed;
        left: -9999px;
        top: -9999px;
    }
    .haibao-container{
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0,0,0,.66);
        z-index: 999;
        padding-top: 35px;
        box-sizing: border-box;
    }
    .haibao-container-tip{
        text-align: center;
        color: #FFF;
        padding: 5px;
    }
    .haibao-container-img{
        padding: 0px 10px;
        overflow-y:auto;
        height: calc(100vh - 80px);
    }
    .haibao-container-img img{
        width: 100%;
    }
    .haibao-container-next{
        text-align: center;
        font-size: 20px;
        position: absolute;
        bottom: 18px;
        width: 100%;
    }
    .haibao-container-top{
        width: 100%;
    }
    .haibao-contents{
        padding: 10px 10px 0;
        box-sizing: border-box;
        position: relative;
    }
    .haibao-contents-t{
        padding: 0;
        box-sizing: border-box;
    }
    .haibao-contents-headimg{
        width: 100%;
        height: 200px;
        display: block;
    }
    .haibao-contents-wrap{
        background: white;
        min-height: calc(100vh - 370px);
        font-size: 16px;
        padding: 20px 20px 120px;
        position: relative;
    }
   
    .haibao-contents-author{
        text-align: right;
        padding-top: 20px;
    }
    .haibao-contents-qr-wrap{
        position: absolute;
        width: calc(100vw - 60px);
        bottom: 20px;
        height: 80px;
        display: flex;
        justify-content: space-between;
    }
    .haibao-contents-qr-left{
        display: flex;
        justify-content: space-between;
    }
    .haibao-contents-qr-head{
        width: 60px;
        height: 60px;
        border-radius: 30px;
    }
    .haibao-contents-qr-userzone{
        padding-left: 10px;
        flex: 1;
    }
    .haibaoq-qr-username{
        font-weight: 600;
        font-size: 11px;
    }
    .haibaoq-qr-tips{
        font-size: 11px;
    }
    .haibaoq-qr-course{
        color: tomato;
    }
    .haibao-contents-qr-right{
        width: 60px;
        text-align: center;
    }
    .haibao-contents-qr-code{
        width: 40px;
        height: 40px;
    }
    .haibao-contents-qr-guide{
        font-size: 11px;
    }
    .baibao-date{
        text-align: right;
        position: absolute;
        z-index: 999;
        text-align: right;
        width: 100%;
        bottom: 0px;
        background: rgba(90, 87, 87, 0.5);
        color: #f9f7f5;
    }
    .haibao-contents-text{
        white-space: pre-wrap
    }
</style>
